import { jsxs as n, jsx as r, Fragment as v } from "react/jsx-runtime";
import { R as k, T as x, P as L, C as I } from "../index-D4JPp1jr.js";
import { Icon as P } from "../Vivid/Icon.js";
import { Checkbox as w } from "../Vivid/Checkbox.js";
import { c as f } from "../index-Cu0xwYjD.js";
import b from "react";
const F = "_trigger_22h04_1", R = "_reset_22h04_25", T = "_hasResetButton_22h04_50", $ = "_triggerLabel_22h04_55", j = "_content_22h04_78", y = "_scaleIn_22h04_1", M = "_disabled_22h04_89", D = "_items_22h04_94", V = "_item_22h04_94", q = "_footerSeparator_22h04_129", z = "_footerButton_22h04_137", t = {
  trigger: F,
  reset: R,
  hasResetButton: T,
  triggerLabel: $,
  content: j,
  scaleIn: y,
  disabled: M,
  items: D,
  item: V,
  footerSeparator: q,
  footerButton: z
}, E = b.createContext({
  close: () => {
  }
}), W = ({
  disabled: _,
  triggerLabel: p,
  options: s,
  selectedOptions: a,
  onOpenChange: h,
  defaultOpen: S = !1,
  onOptionClick: g,
  onReset: c,
  footerAction: o
}) => {
  const [N, B] = b.useState(S), i = (e) => {
    B(e), h == null || h(e);
  }, C = `${p}: ${a.length === s.length ? "All" : a.length === 1 ? a[0].label : `${a.length} selected`}`, d = c && a.length !== s.length;
  return /* @__PURE__ */ n(k, { open: N, onOpenChange: i, children: [
    /* @__PURE__ */ r(x, { asChild: !0, children: /* @__PURE__ */ n(
      "button",
      {
        className: f(
          t.trigger,
          d && t.hasResetButton
        ),
        children: [
          /* @__PURE__ */ r("div", { className: t.triggerLabel, children: C }),
          d && /* @__PURE__ */ r(
            "div",
            {
              className: t.reset,
              onClick: (e) => {
                e.stopPropagation(), c == null || c(), i(!1);
              },
              children: P.close
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ r(L, { children: /* @__PURE__ */ r(
      I,
      {
        align: "start",
        className: f(t.content, _ && t.disabled),
        sideOffset: 5,
        onOpenAutoFocus: (e) => e.preventDefault(),
        children: /* @__PURE__ */ r(
          E.Provider,
          {
            value: { close: () => i(!1) },
            children: /* @__PURE__ */ n("div", { className: t.container, children: [
              /* @__PURE__ */ r("div", { className: t.items, children: s.map((e, u) => /* @__PURE__ */ r(
                w,
                {
                  className: t.item,
                  id: u.toString(),
                  checked: a.map((l) => l.param).includes(e.param),
                  option: e,
                  label: e.label,
                  disabled: _,
                  onOnlyClick: () => {
                    const l = [e];
                    g({
                      selectedOptions: l,
                      allOptionsSelected: l.length === s.length
                    }), i(!1);
                  },
                  onValueChange: () => {
                    const l = a.map((m) => m.param).includes(e.param) ? (
                      // If it is, remove it
                      a.filter(
                        (m) => m.param !== e.param
                      )
                    ) : (
                      // If it isn't, add it
                      [...a, e]
                    );
                    g({
                      selectedOptions: l,
                      allOptionsSelected: l.length === s.length
                    });
                  }
                },
                u.toString()
              )) }),
              o && /* @__PURE__ */ n(v, { children: [
                /* @__PURE__ */ r("span", { className: t.footerSeparator }),
                /* @__PURE__ */ n(
                  "button",
                  {
                    onClick: o.onClick,
                    className: t.footerButton,
                    children: [
                      o.icon,
                      " ",
                      o.label
                    ]
                  }
                )
              ] })
            ] })
          }
        )
      }
    ) })
  ] });
};
export {
  W as FilterMenu
};
